import { render, staticRenderFns } from "./CommunicationLogs.vue?vue&type=template&id=34afb248&"
import script from "./CommunicationLogs.vue?vue&type=script&lang=js&"
export * from "./CommunicationLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports